// "Los más pedidos" de /services, por slug: se muestran TODOS en un carrusel
// (4 a la vez en escritorio, 2 en el teléfono; Diego, 03-11-2026).
// ESTE ORDEN NO SALE DE DATOS DE USO. Es una elección a mano de Diego
// (03-11-2026), provisoria hasta que haya solicitudes reales: producción no
// tiene pedidos y los de dev son ensayos. Cuando los haya, se reemplaza por
// un conteo.
export const SERVICIOS_DESTACADOS = [
  'plomeros',
  'electricista',
  'gasista',
  'cerrajeria',
  'aire_acondicionado',
  'pintores',
  'albanileria',
  'jardinero',
];

export const DESTACADOS_SERVICIOS = SERVICIOS_DESTACADOS.length;
